var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('BackHeader'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('BackMenu'),_c('BackMain',[_c('keep-alive',{attrs:{"include":['ArticleListPage']}},[_c('router-view')],1)],1)],1)]),_c('link',{attrs:{"rel":"stylesheet","href":"/static/css/dashboard.css"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }